import Mountain from "./mountain_inverse.png";

const Header = ({ className }) => {
  return (
    <div className={className}>
      <img src={Mountain} alt="mountain" style={{ width: "8vw" }} />
      <h1 style={{ marginTop: 0, marginBottom: 0 }}>Megan & Derek</h1>
    </div>
  );
};

export default Header;
